import { createFileRoute } from '@tanstack/react-router';
import { DispatchManual } from '../../../features/sales-invoicing/DispatchManual';

/** Ticket-less dispatch (no weighbridge ticket) for counted goods — boxed
 * firelighters, bagged/crated firewood — the counterpart to `/sales-invoicing`
 * (DispatchWizard, the weighbridge-ticket path), mirroring `/purchasing-intake/
 * receive-manual`'s identical twin relationship to `/purchasing-intake`. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/dispatch-manual')({
  component: DispatchManual,
});
